<template>
  <div>
    <v-chip
      class="ml-2"
      v-for="(filter, index) in filters"
      :key="index"
      close
      small
      @click:close="removeFilterByID(filter.id)"
      >{{ filter.label }}</v-chip
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    removeFilterByID(id) {
      this.$store.dispatch("groupFilters/removeFilterByID", id);
      this.$emit("filtersUpdated");
    }
  },
  computed: {
    ...mapGetters({
      filters: "groupFilters/displayed"
    })
  }
};
</script>

<style></style>
